import type { Mode } from '@/types/entity-mode';
import type { FlowMode } from '@/types/dtos/flows/response/flow.dto';

export const isEntityOfMode = (mode: Mode, entityMode?: Mode | FlowMode): boolean => {
  const normalizedEntityMode = entityMode === 'PLAY' ? 'PLAN' : entityMode;
  if (mode === normalizedEntityMode) return true;
  if (mode === 'PLAN' && normalizedEntityMode === undefined) return true;
  return false;
};

export const isOrganizeMode = (mode: Mode): boolean => {
  return mode === 'ORGANIZE' || mode === 'PERFORM';
};
